export default "__VITE_ASSET__Ct03$$Zd__"